module.exports = " <div class=\"progress-container is-flex\"> <progress :class=\"['progress', type ? `is-${type}` : '', size ? `is-${size}` : '']\" :value=value :max=max></progress> <span v-if=showLabel>{{percentage + '%'}}</span> </div> ";


//////////////////
// WEBPACK FOOTER
// ./~/vue-html-loader!./~/vue-loader/lib/selector.js?type=template&index=0!./~/vue-bulma-progress-bar/src/ProgressBar.vue
// module id = 927
// module chunks = 2